// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"1ca5aada","833":"650d1ef6"}[chunkId] + ".chunk.js";
};